import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import Login from "components/Login/Login";

import { style } from "variables/Variables.jsx";
//import { Button } from "react-bootstrap";
import dashboardRoutes from "routes/dashboard.jsx";
import Charts from "views/Charts/Charts";
import UserProfile from "views/UserProfile/UserProfile";
import TableList from "views/TableList/TableList";
import Dashboard2 from "views/Dashboard/Dashboard2";

//import { truncate } from "fs";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.state = {
      _notificationSystem: null
    };
  }

  handleNotificationClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift" />,
      message: (
        <div>
          Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
          every web developer.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15
    });
  }
  componentDidMount() {
    // this.setState({ _notificationSystem: this.refs.notificationSystem });
    // var _notificationSystem = this.refs.notificationSystem;
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    // _notificationSystem.addNotification({
    //   title: <span data-notify="icon" className="pe-7s-gift" />,
    //   message: (
    //     <div>
    //       Welcome to <b>Light Bootstrap Dashboard</b> - a beautiful freebie for
    //       every web developer.
    //     </div>
    //   ),
    //   level: level,
    //   position: "tr",
    //   autoDismiss: 15
    // });
  }
  onLogout = () => {
    this.setState({ user: null });
  };
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  handleLogin = userData => {
    userData.user.id === 6
      ? userData.device.map((device, key) => {
          device.desc = "Demo " + (key + 1);
        })
      : false;
    this.setState({ user: userData });
  };

  render() {
    return (
      <div className="wrapper">
        {this.state.user && (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <Sidebar
              logout={this.onLogout}
              {...this.props}
              userData={this.state.user ? this.state.user.user : null}
            />
            <div id="main-panel" className="main-panel" ref="mainPanel">
              <Header
                logout={this.onLogout}
                {...this.props}
                userData={this.state.user ? this.state.user.user : null}
              />

              <Switch>
                {dashboardRoutes.map((prop, key) => {
                  //console.log(prop);

                  if (prop.name === "Notifications")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <prop.component
                            {...routeProps}
                            handleClick={this.handleNotificationClick}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/dashboard")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={props => (
                          <Dashboard2
                            device={this.state.user.device}
                            lastMeasurement={this.state.user.lastMeasurement}
                            lastMessage={this.state.user.lastMessage}
                            {...props}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/charts")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <Charts
                            {...routeProps}
                            device={this.state.user.device}
                          />
                        )}
                      />
                    );
                  if (prop.path === "/table")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={routeProps => (
                          <TableList
                            {...routeProps}
                            device={this.state.user.device}
                            lastMeasurement={this.state.user.lastMeasurement}
                            lastMessage={this.state.user.lastMessage}
                          />
                        )}
                      />
                    );
                  if (prop.redirect)
                    return <Redirect from={prop.path} to={prop.to} key={key} />;
                  if (prop.path === "/user")
                    return (
                      <Route
                        path={prop.path}
                        key={key}
                        render={props => (
                          <UserProfile
                            userData={this.state.user.user}
                            {...props}
                          />
                        )}
                      />
                    );
                  else
                    return (
                      <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                        user={this.state.user}
                      />
                    );
                })}
              </Switch>

              {!this.state.user && <Login onLogin={this.handleLogin} />}

              <Footer />
            </div>
          </div>
        )}
        {!this.state.user && <Login onLogin={this.handleLogin} />}
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx